var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFoundTimes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 102,
    viewBox: "0 0 103 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3194_5671)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.5586,
    cy: 66.5,
    r: 33.5,
    fill: "#EAECFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5371 3C65.5371 3 35.6919 3.01555 35.6452 3.01555C24.9154 3.08164 18.2715 10.1416 18.2715 20.9103V56.6608C18.2715 67.4839 24.966 74.5711 35.7891 74.5711C35.7891 74.5711 65.6304 74.5594 65.681 74.5594C76.4108 74.4933 83.0586 67.4295 83.0586 56.6608V20.9103C83.0586 10.0871 76.3603 3 65.5371 3Z",
    fill: "white",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 48.5H67C71.4183 48.5 75 52.0817 75 56.5V56.5C75 60.9183 71.4183 64.5 67 64.5H41.5",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2598 76.0693L3.06488 83.2455",
    stroke: "#513DD3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3516,
    cy: 18.3516,
    rx: 18.3516,
    ry: 18.3516,
    transform: "matrix(-1 0 0 1 41.375 44)",
    fill: "white",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    transform: "matrix(-1 0 0 1 37.5 48)",
    fill: "#EAECFF",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3194_5671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3664 32.7507L70.6458 16.4713",
    stroke: "#DB3C9E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6457 32.7508L54.3663 16.4713",
    stroke: "#DB3C9E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3194_5671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3194_5671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white",
    transform: "translate(47 9.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundTimes);
export default __webpack_public_path__ + "static/media/NotFoundTimes.a32764737c39a696352da777acf30c7f.svg";
export { ForwardRef as ReactComponent };